var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cc-input-box" }, [
    _vm.title
      ? _c("label", { staticClass: "cc-label" }, [_vm._v(_vm._s(_vm.title))])
      : _vm._e(),
    _c("div", { staticClass: "cc-input-content", style: _vm.styleObject }, [
      _c("input", {
        ref: "input",
        staticClass: "cc-input",
        class: { errorBorder: _vm.error },
        style: _vm.styleObject,
        attrs: {
          type: "text",
          autocomplete: _vm.autoComplete,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          pattern: _vm.validator
        },
        domProps: { value: _vm.currentValue },
        on: {
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur
        }
      }),
      _vm.isDeleteBtn && !_vm.disabled
        ? _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentValue,
                expression: "currentValue"
              }
            ],
            staticClass: "cc-input-icon-delet",
            on: { click: _vm.handleIconClick }
          })
        : _vm._e(),
      _vm.showInputList && _vm.inputlistdata && _vm.inputlistdata.length
        ? _c(
            "ul",
            { staticClass: "cc-input-list", style: _vm.styleObject },
            _vm._l(_vm.inputlistdata, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "cc-input-item",
                  on: {
                    click: function($event) {
                      return _vm.handleSelect(item)
                    }
                  }
                },
                [_vm._t("itemText", null, { item: item })],
                2
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b534cd9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b534cd9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Cc-Input/Input.vue
// module id = HqiG
// module chunks = 0 3